import { useState, useEffect } from 'react';
import { macOSNotificationManager } from '@/utils/macOSNotificationManager.ts';

interface NotificationData {
  id: string;
  title: string;
  description: string;
}

export const useMacOSNotifications = () => {
  const [notifications, setNotifications] = useState<NotificationData[]>([]);

  useEffect(() => {
    // Subscribe to notification changes
    const unsubscribe = macOSNotificationManager.subscribe((newNotifications) => {
      setNotifications(newNotifications);
    });

    // Get initial notifications
    setNotifications(macOSNotificationManager.getNotifications());

    return unsubscribe;
  }, []);

  return {
    notifications,
    addNotification: macOSNotificationManager.addNotification.bind(macOSNotificationManager),
    removeNotification: macOSNotificationManager.removeNotification.bind(macOSNotificationManager),
    clearAllNotifications: macOSNotificationManager.clearAllNotifications.bind(macOSNotificationManager)
  };
};